import images from "@assets/images";
import { useLobbyService } from "@src/ducks/hooks";
import React from "react";
import { Image, View } from "react-native";
import Avatars from "screens/avatar";
import Settings from "screens/settings";
import BottomNav from "../bottomnav";
import CurtainDialog from "../curtain";
import Lobby from "../lobby";
import SideDrawer from "../side-drawer";
import TopNav from "../topnav";
import HomeProvider from "./HomeProvider";
import useStyles from "./styles.css";

const Home = () => {
  const styles = useStyles();
  const { onLobbyRequest } = useLobbyService();

  React.useEffect(() => {
    onLobbyRequest();
  }, []);

  return (
    <HomeProvider>
      <View style={styles.container}>
        <Image
          source={{uri: images["gamezone-bg"]}}
          style={[styles.ib_style]}
          resizeMode="stretch"
        />
        <SideDrawer />
        <TopNav />
        <Lobby />
        <BottomNav />
        <Settings />
        <Avatars />
        <CurtainDialog />
      </View>
    </HomeProvider>
  );
};

export default React.memo(Home);
